module.exports = __webpack_public_path__ + "img/bank.8d0fca38.svg";